import React from "react";
import MainTable from "../../../components/request-table/request-table";

////////////////////////////////////////////////TABLE COLUMN HEADERS SET UP////////////////////////////////////////////////////////////////////////////////////////
const TableData = ({ resetMenu }: any) => {
  return <MainTable pageTitle="KYC Request Pending" pageName="pending" resetMenu={resetMenu}/>;
};
export default TableData;
